import React, { useState, useEffect, useRef } from 'react'

import { Link, useNavigate } from 'react-router-dom'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import update from 'immutability-helper'
import { Checkbox, FormControlLabel, FormGroup, Tooltip } from '@mui/material'
import { useAuth } from '../../hooks/auth'

import AppLayout from '../Layouts/AppLayout'
import { useTranslation } from 'react-i18next'
import { useStateContext } from '../../context/ContextProvider'
import axios from '../../lib/axios'
import '../../BrokerCalendar.css'
import Loading from '../Loading'
import { isValid } from '../../helpers/helper'
import Navigation from '../sales_purchase_orders/Navigation'
import i18next from 'i18next'
import allLocales from '@fullcalendar/core/locales-all'
import { includes } from 'lodash'
import dayjs from 'dayjs'
import { buildUrl } from '../../helpers/apiHelper'

const CalendarBroker = () => {

    const { user } = useAuth({ middleware: 'guest ' })

    const { t } = useTranslation()
    const [orders, setOrders] = useState([])
    const { config, choosesite, pusher } = useStateContext()
    const calendarRef = useRef(null)
    const navigate = useNavigate()
    const [isLoading, setIsLoading] = useState(false)

    const [shipmentsChecked, setShipmentsChecked] = useState(() => {
        if(localStorage.getItem('filters') !== null) {
            const filters = JSON.parse(localStorage.getItem('filters'));
            return filters[0]?.broker_calendar_shipments_checked ?? true;
        } else {
            return true;
        }
    })
    const [collectionsChecked, setCollectionsChecked] = useState(() => {
        if(localStorage.getItem('filters') !== null) {
            const filters = JSON.parse(localStorage.getItem('filters'));
            return filters[0]?.broker_calendar_collections_checked ?? true;
        } else {
            return true;
        }
    })

    const [events, setEvents] = useState([])

    useEffect(() => {
        // Unsubscribe on unmount
        return (() => {
            pusher.unsubscribe(`${localStorage.getItem('client_id')}-salesorder-deleted-site-${localStorage.getItem('site')}`)
            pusher.unsubscribe(`${localStorage.getItem('client_id')}-salesorder-created-site-${localStorage.getItem('site')}`)
            pusher.unsubscribe(`${localStorage.getItem('client_id')}-salesorder-updated-site-${localStorage.getItem('site')}`)
        })
    }, [])

    useEffect(() => {
        if(isValid(choosesite)) {
            const channeldelete = pusher.subscribe(`${localStorage.getItem('client_id')}-salesorder-deleted-site-${choosesite}`)
            const channelcreate = pusher.subscribe(`${localStorage.getItem('client_id')}-salesorder-created-site-${choosesite}`)
            const channelupdate = pusher.subscribe(`${localStorage.getItem('client_id')}-salesorder-updated-site-${choosesite}`)

            channeldelete.bind(`${localStorage.getItem('client_id')}-salesorder-deleted-event-site-${choosesite}`, data => {
                setOrders((prev) => {
                    const item = prev.find((i) => i.id === data.id)
                    const exItem = prev.filter((i) => i.id !== item.id)
                    return exItem
                })
            })

            channelcreate.bind(`${localStorage.getItem('client_id')}-salesorder-created-event-site-${choosesite}`, data => {
                getSalesOrder(data.id, 'created')
            })

            channelupdate.bind(`${localStorage.getItem('client_id')}-salesorder-updated-event-site-${choosesite}`, data => {
                getSalesOrder(data.id, 'updated')
            })
        }

        return (() => {
            if(isValid(choosesite)) {
                pusher.unsubscribe(`${localStorage.getItem('client_id')}-salesorder-deleted-site-${choosesite}`)
                pusher.unsubscribe(`${localStorage.getItem('client_id')}-salesorder-created-site-${choosesite}`)
                pusher.unsubscribe(`${localStorage.getItem('client_id')}-salesorder-updated-site-${choosesite}`)
            }
        })
    }, [choosesite])

    useEffect(() => {
        setEvents([])
        orders.map((i) => {
            const explodedRequestedDeliveryDate = i.requested_delivery_date.split(' ')[0];
            const explodedRequestedDeliveryTime = i?.requested_delivery_time
                ? i.requested_delivery_time.split(' ')[1]
                : (i?.pickup_appointment_time
                    ? i.pickup_appointment_time.split(' ')[1]
                    : '00:00:00'
                );

            let newEvent = {
                "order_id": i.id,
                "title": i.sales_order?.so_number + ' ' + i.purchase_order?.po_number,
                "date": `${explodedRequestedDeliveryDate}T${explodedRequestedDeliveryTime}`,
                "requested_delivery_date": i.requested_delivery_date,
                "allDay": (i?.requested_delivery_time || i?.pickup_appointment_time) ? false : true,
                "transaction_type": i.type
            }

            setEvents((prev) => [...prev, newEvent])
        })
    }, [orders])

    useEffect(() => {
        createFilterArray(shipmentsChecked, collectionsChecked)
    }, [shipmentsChecked, collectionsChecked])

    {/* Functions */}

    const createFilterArray = (shipmentsChecked, collectionsChecked) => {
        if (localStorage.getItem('filters') === null) {
            let filter = [{}];
            localStorage.setItem('filters', JSON.stringify(filter));
        }

        let filters = JSON.parse(localStorage.getItem('filters'));

        filters[0].broker_calendar_shipments_checked = shipmentsChecked;
        filters[0].broker_calendar_collections_checked = collectionsChecked;

        localStorage.setItem('filters', JSON.stringify(filters));
    }

    const getOrders = async (
        siteId,
        timespan = 'dayGridMonth',
        day = null,
        month = null,
        year = null
    ) => {
        setEvents([])
        setIsLoading(true)

        const url = buildUrl(
            `/api/frontend-calendar/broker`,
            {
                where: {
                    site_id: siteId,
                    timespan: timespan,
                    day: day,
                    month: month,
                    year: year
                }
            }
        )

        await axios.get(url, config)
            .then(({ data }) => setOrders(data?.data))
            .finally(() => setIsLoading(false))
    }

    const getSalesOrder = async (id, state) => {
        setIsLoading(true)
        await axios.get(`/api/sales-orders/${id}`, config)
            .then(res => {
                const salesOrder = res.data
                if (state === 'created') setOrders((prev) => [...prev, salesOrder])

                if (state === 'updated') setOrders((prev) => {

                    const index = prev?.findIndex((i) => i.id === id)
                    if (index < 0) {
                        const items = [...prev, salesOrder]
                        return items
                    } else {
                        if (salesOrder.so_status === "completed") {
                            return update(prev, { $splice: [[index, 1]] })
                        } else {
                            return update(prev,
                                { [index]: { $set: salesOrder } }
                            )
                        }
                    }
                })
            })
            .catch(({ response }) => {})
            .finally(() => setIsLoading(false))

    }

    const handleEventClick = (eventInfo) => {
        localStorage.setItem('initialDateBroker', eventInfo.event.extendedProps.requested_delivery_date)
        navigate(`/broker-transactions/${eventInfo.event.extendedProps.order_id}`);
    }

    const handleDatesSet = (arg) => {
        const calendarApi = calendarRef.current?.getApi();
        if(!calendarApi) {
            let initialDate = null;
            try {
                initialDate = dayjs(localStorage.getItem('initialDateBroker'));
            } catch (e) {
                initialDate = dayjs();
            }

            getOrders(
                localStorage.getItem('site'),
                'dayGridMonth',
                initialDate.isValid() ? initialDate.date() : null,
                initialDate.isValid() ? (initialDate.month() + 1) : null,
                initialDate.isValid() ? initialDate.year() : null
            );

            return
        };

        const currentDate = dayjs(calendarApi.getDate());

        const day = currentDate.date();
        const month = currentDate.month() + 1;
        const year = currentDate.year();
        const timespan = arg?.view?.type;

        getOrders(
            localStorage.getItem('site'),
            timespan,
            day,
            month,
            year
        );
    }

    return (
        <>
            {isLoading ? <Loading /> : null}
            <AppLayout>
                <Navigation route='broker-transactions' type='calendar' user={user} />

                <FormGroup
                    row={true}
                    sx={{
                        marginX: '24px',
                        justifyContent: 'end',
                        flexWrap: {
                            xs: 'wrap',
                            lg: 'nowrap'
                        }
                    }}
                >
                    <FormControlLabel
                        control={<Checkbox checked={shipmentsChecked} onChange={(e) => setShipmentsChecked(e.target.checked)} />}
                        label={t('shipments')}
                    />

                    <FormControlLabel
                        control={<Checkbox checked={collectionsChecked} onChange={(e) => setCollectionsChecked(e.target.checked)} />}
                        label={t('collections')}
                    />
                </FormGroup>

                <div className='p-5 w-full'>
                    <div className='p-2 bg-white mb-2 rounded-md broker'>
                        <FullCalendar
                            locales={allLocales}
                            locale={i18next?.resolvedLanguage ?? 'en'}
                            ref={calendarRef}
                            plugins={[dayGridPlugin, timeGridPlugin]}
                            headerToolbar={{
                                left: 'prev,next today',
                                center: 'title',
                                right: 'dayGridMonth,timeGridWeek,timeGridDay'
                            }}
                            buttonText={{
                                today: t('today'),
                                month: t('month'),
                                week: t('week'),
                                day: t('day')
                            }}
                            customButtons={{
                                today: {
                                    text: t('today'),
                                    click: () => {
                                        localStorage.removeItem('initialDateBroker')
                                        let calendarApi = calendarRef.current.getApi()
                                        calendarApi.today()
                                    }
                                }
                            }}
                            initialView='dayGridMonth'
                            events={events.filter((e) => {
                                if(e.transaction_type === 'shipment' && shipmentsChecked) {
                                    return true;
                                }

                                if(e.transaction_type === 'collection' && collectionsChecked) {
                                    return true;
                                }

                                return false;
                            })}
                            eventContent={RenderEventContent}
                            dayMaxEvents={true}
                            eventMaxStack={1}
                            expandRows={true}
                            eventColor='#ffffff'
                            initialDate={localStorage.getItem('initialDateBroker')}
                            eventClick={handleEventClick}
                            datesSet={handleDatesSet}
                        />
                    </div>
                </div>
            </AppLayout>
        </>
    )
}

export default CalendarBroker

const RenderEventContent = (eventInfo) => {
    const { transaction_type } = eventInfo.event.extendedProps;

    const getEventColor = (transactionType) => {
        let className = '';

        switch(transactionType) {
            case "shipment":
                className = "bg-[#336195]";
                break;
            case "collection":
                className = "bg-[#b7472a]";
                break;
            default:
                className = "bg-[#148c8cb3]";
        }

        return className;
    }

    return (
        <Tooltip disableInteractive placement='bottom' title={
            <div className='flex flex-col'>
                <p className='text-[16px] pb-3'>{eventInfo.event.title}</p>
            </div>
        }>
            <button className='w-full'>
                <div className={`p-1 flex flex-col text-left ${getEventColor(transaction_type)} text-white rounded-sm`}>
                    <p className='text-xl bold p-1 roboto'>{eventInfo.event.title}</p>
                </div>
            </button>
        </Tooltip>
    )
}


